import app from 'flarum/forum/app';
import Group from 'flarum/common/models/Group';

// Core's Group::MODERATOR_ID - its JS Group model has no such constant.
const MODERATOR_GROUP_ID = '4';

/**
 * The team, as phpBB's "L'équipe" listed it: the Admins and Mods groups.
 * The member list's "L'équipe" link (addMembersMenu.tsx) and its only
 * "Filtrer par groupe" choices (addMemberList.tsx).
 */
export const STAFF_GROUP_IDS = [Group.ADMINISTRATOR_ID, MODERATOR_GROUP_ID];

/**
 * The member list filtered on the team - the "groupe:1,4" search
 * fof/user-directory's own group filter writes (its keyword is translated,
 * hence the lookup).
 */
export function staffQuery() {
  const groupKey = app.translator.trans('core.lib.gambits.users.group.key', {}, true);
  return `${groupKey}:${STAFF_GROUP_IDS.join(',')}`;
}
flarum.reg.add('champis-users', 'forum/utils/staffGroups', { STAFF_GROUP_IDS: STAFF_GROUP_IDS,staffQuery: staffQuery, });